import api from './api';

/**
 * Activity Log Service
 * Handles logging and managing activity logs for users
 */
export const activityLogService = {

  /**
   * Log a new activity
   */
  async logActivity(request, servletRequest) {
    return api.post('/activity-logs', request);
  },

  
  /**
   * Get activity logs by user ID
   */
  async getActivityLogsByUser(userId, limit = 10) {
    return api.get(`/activity-logs/user/${userId}?limit=${limit}`);
  },

  /**
   * Get activity logs for the current user
   */
  async getMyActivityLogs(limit = 10) {
    return api.get(`/activity-logs/?limit=${limit}`);
  }
};

export default activityLogService;
